import React from "react";

export const SectionHeading = ({ children }) => (
  <div className="section-heading mb-6">
    <h2 className="font-display text-2xl sm:text-[32px] font-medium tracking-tight text-center">{children}</h2>
  </div>
);
